var _path, _circle, _circle2, _path2, _circle3, _circle4, _path3, _circle5, _circle6, _path4, _circle7, _circle8, _path5, _circle9, _circle10, _path6, _circle11, _circle12, _path7, _circle13, _circle14, _path8, _circle15, _circle16, _path9, _circle17, _circle18, _path10, _circle19, _circle20, _path11, _circle21, _circle22, _path12, _circle23, _circle24, _path13, _circle25, _circle26, _path14, _circle27, _circle28, _path15, _circle29, _circle30, _path16, _circle31, _circle32, _path17, _circle33, _circle34, _path18, _circle35, _circle36, _path19, _circle37, _circle38, _path20, _circle39, _circle40, _path21, _circle41, _circle42, _path22, _circle43, _circle44, _path23, _circle45, _circle46, _path24, _circle47, _circle48, _path25, _circle49, _circle50;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTutoringPattern = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 306,
  height: 300,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.75 3.633c0-.71.85-1.074 1.363-.585l10.898 10.38c.527.502.172 1.39-.556 1.39H1.557a.807.807 0 0 1-.807-.807V3.633ZM47.598 35.2a.807.807 0 0 0-1.364-.583L35.337 44.996c-.528.502-.172 1.39.556 1.39h10.898a.807.807 0 0 0 .807-.806V35.2Z",
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 40.348,
  cy: 7,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 40.137,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M65.098 3.633c0-.71.85-1.074 1.363-.585l10.898 10.38c.527.502.172 1.39-.557 1.39H65.904a.807.807 0 0 1-.806-.807V3.633ZM111.945 35.2a.807.807 0 0 0-1.363-.583L99.684 44.996c-.527.502-.172 1.39.557 1.39h10.897a.807.807 0 0 0 .807-.806V35.2Z",
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 104.695,
  cy: 7,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 72.348,
  cy: 40.137,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M129.445 3.633c0-.71.85-1.074 1.364-.585l10.897 10.38c.528.502.172 1.39-.556 1.39h-10.898a.807.807 0 0 1-.807-.807V3.633ZM176.293 35.2a.807.807 0 0 0-1.363-.583l-10.898 10.379c-.527.502-.172 1.39.556 1.39h10.898a.807.807 0 0 0 .807-.806V35.2Z",
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 169.043,
  cy: 7,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 136.695,
  cy: 40.137,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M193.793 3.633c0-.71.85-1.074 1.363-.585l10.898 10.38c.527.502.172 1.39-.556 1.39H194.6a.807.807 0 0 1-.807-.807V3.633ZM240.641 35.2a.807.807 0 0 0-1.364-.583L228.38 44.996c-.528.502-.172 1.39.556 1.39h10.898a.807.807 0 0 0 .807-.806V35.2Z",
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
  cx: 233.391,
  cy: 7,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
  cx: 201.043,
  cy: 40.137,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M258.141 3.633a.807.807 0 0 1 1.363-.585l10.898 10.38c.527.502.172 1.39-.557 1.39h-10.898a.806.806 0 0 1-.806-.807V3.633ZM304.988 35.2a.807.807 0 0 0-1.363-.583l-10.898 10.379c-.527.502-.172 1.39.557 1.39h10.897a.807.807 0 0 0 .807-.806V35.2Z",
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
  cx: 297.738,
  cy: 7,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
  cx: 265.391,
  cy: 40.137,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M.75 66.77c0-.71.85-1.074 1.363-.585l10.898 10.379c.527.502.172 1.391-.556 1.391H1.557a.807.807 0 0 1-.807-.807V66.77ZM47.598 98.338a.807.807 0 0 0-1.364-.585l-10.897 10.379c-.528.503-.172 1.391.556 1.391h10.898a.807.807 0 0 0 .807-.807V98.338Z",
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
  cx: 40.348,
  cy: 70.137,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 103.273,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M65.098 66.77c0-.71.85-1.074 1.363-.585l10.898 10.379c.527.502.172 1.391-.557 1.391H65.904a.807.807 0 0 1-.806-.807V66.77ZM111.945 98.338a.807.807 0 0 0-1.363-.585l-10.898 10.379c-.527.503-.172 1.391.557 1.391h10.897a.807.807 0 0 0 .807-.807V98.338Z",
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
  cx: 104.695,
  cy: 70.137,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
  cx: 72.348,
  cy: 103.273,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M129.445 66.77c0-.71.85-1.074 1.364-.585l10.897 10.379c.528.502.172 1.391-.556 1.391h-10.898a.807.807 0 0 1-.807-.807V66.77ZM176.293 98.338a.807.807 0 0 0-1.363-.585l-10.898 10.379c-.527.503-.172 1.391.556 1.391h10.898a.807.807 0 0 0 .807-.807V98.338Z",
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
  cx: 169.043,
  cy: 70.137,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
  cx: 136.695,
  cy: 103.273,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M193.793 66.77c0-.71.85-1.074 1.363-.585l10.898 10.379c.527.502.172 1.391-.556 1.391H194.6a.807.807 0 0 1-.807-.807V66.77ZM240.641 98.338a.807.807 0 0 0-1.364-.585l-10.897 10.379c-.528.503-.172 1.391.556 1.391h10.898a.807.807 0 0 0 .807-.807V98.338Z",
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
  cx: 233.391,
  cy: 70.137,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
  cx: 201.043,
  cy: 103.273,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M258.141 66.77a.807.807 0 0 1 1.363-.585l10.898 10.379c.527.502.172 1.391-.557 1.391h-10.898a.807.807 0 0 1-.806-.807V66.77ZM304.988 98.338a.807.807 0 0 0-1.363-.585l-10.898 10.379c-.527.503-.172 1.391.557 1.391h10.897a.807.807 0 0 0 .807-.807V98.338Z",
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
  cx: 297.738,
  cy: 70.137,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
  cx: 265.391,
  cy: 103.273,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M.75 129.906a.807.807 0 0 1 1.363-.584l10.898 10.379c.527.502.172 1.391-.556 1.391H1.557a.807.807 0 0 1-.807-.807v-10.379ZM47.598 161.474a.807.807 0 0 0-1.364-.584l-10.897 10.379c-.528.502-.172 1.391.556 1.391h10.898a.807.807 0 0 0 .807-.807v-10.379Z",
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
  cx: 40.348,
  cy: 133.273,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 166.41,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M65.098 129.906a.807.807 0 0 1 1.363-.584l10.898 10.379c.527.502.172 1.391-.557 1.391H65.904a.807.807 0 0 1-.806-.807v-10.379ZM111.945 161.474a.807.807 0 0 0-1.363-.584l-10.898 10.379c-.527.502-.172 1.391.557 1.391h10.897a.807.807 0 0 0 .807-.807v-10.379Z",
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
  cx: 104.695,
  cy: 133.273,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
  cx: 72.348,
  cy: 166.41,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M129.445 129.906a.807.807 0 0 1 1.364-.584l10.897 10.379c.528.502.172 1.391-.556 1.391h-10.898a.808.808 0 0 1-.807-.807v-10.379ZM176.293 161.474a.807.807 0 0 0-1.363-.584l-10.898 10.379c-.527.502-.172 1.391.556 1.391h10.898a.807.807 0 0 0 .807-.807v-10.379Z",
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
  cx: 169.043,
  cy: 133.273,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
  cx: 136.695,
  cy: 166.41,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M193.793 129.906a.807.807 0 0 1 1.363-.584l10.898 10.379c.527.502.172 1.391-.556 1.391H194.6a.807.807 0 0 1-.807-.807v-10.379ZM240.641 161.474a.807.807 0 0 0-1.364-.584l-10.897 10.379c-.528.502-.172 1.391.556 1.391h10.898a.807.807 0 0 0 .807-.807v-10.379Z",
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
  cx: 233.391,
  cy: 133.273,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
  cx: 201.043,
  cy: 166.41,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M258.141 129.906a.807.807 0 0 1 1.363-.584l10.898 10.379c.527.502.172 1.391-.557 1.391h-10.898a.807.807 0 0 1-.806-.807v-10.379ZM304.988 161.474a.807.807 0 0 0-1.363-.584l-10.898 10.379c-.527.502-.172 1.391.557 1.391h10.897a.807.807 0 0 0 .807-.807v-10.379Z",
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
  cx: 297.738,
  cy: 133.273,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
  cx: 265.391,
  cy: 166.41,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M.75 193.043c0-.71.85-1.074 1.363-.585l10.898 10.379c.527.503.172 1.391-.556 1.391H1.557a.807.807 0 0 1-.807-.806v-10.379ZM47.598 224.611a.807.807 0 0 0-1.364-.584l-10.897 10.379c-.528.502-.172 1.391.556 1.391h10.898a.807.807 0 0 0 .807-.807v-10.379Z",
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
  cx: 40.348,
  cy: 196.41,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 229.547,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M65.098 193.043c0-.71.85-1.074 1.363-.585l10.898 10.379c.527.503.172 1.391-.557 1.391H65.904a.806.806 0 0 1-.806-.806v-10.379ZM111.945 224.611a.807.807 0 0 0-1.363-.584l-10.898 10.379c-.527.502-.172 1.391.557 1.391h10.897a.807.807 0 0 0 .807-.807v-10.379Z",
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
  cx: 104.695,
  cy: 196.41,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
  cx: 72.348,
  cy: 229.547,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M129.445 193.043c0-.71.85-1.074 1.364-.585l10.897 10.379c.528.503.172 1.391-.556 1.391h-10.898a.807.807 0 0 1-.807-.806v-10.379ZM176.293 224.611a.807.807 0 0 0-1.363-.584l-10.898 10.379c-.527.502-.172 1.391.556 1.391h10.898a.807.807 0 0 0 .807-.807v-10.379Z",
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
  cx: 169.043,
  cy: 196.41,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
  cx: 136.695,
  cy: 229.547,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "M193.793 193.043c0-.71.85-1.074 1.363-.585l10.898 10.379c.527.503.172 1.391-.556 1.391H194.6a.806.806 0 0 1-.807-.806v-10.379ZM240.641 224.611a.807.807 0 0 0-1.364-.584l-10.897 10.379c-.528.502-.172 1.391.556 1.391h10.898a.807.807 0 0 0 .807-.807v-10.379Z",
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
  cx: 233.391,
  cy: 196.41,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
  cx: 201.043,
  cy: 229.547,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  d: "M258.141 193.043a.807.807 0 0 1 1.363-.585l10.898 10.379c.527.503.172 1.391-.557 1.391h-10.898a.806.806 0 0 1-.806-.806v-10.379ZM304.988 224.611a.807.807 0 0 0-1.363-.584l-10.898 10.379c-.527.502-.172 1.391.557 1.391h10.897a.807.807 0 0 0 .807-.807v-10.379Z",
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
  cx: 297.738,
  cy: 196.41,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
  cx: 265.391,
  cy: 229.547,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "M.75 256.179a.807.807 0 0 1 1.363-.584l10.898 10.379c.527.502.172 1.391-.556 1.391H1.557a.807.807 0 0 1-.807-.807v-10.379ZM47.598 287.748a.806.806 0 0 0-1.364-.584l-10.897 10.378c-.528.503-.172 1.391.556 1.391h10.898a.807.807 0 0 0 .807-.806v-10.379Z",
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
  cx: 40.348,
  cy: 259.547,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 292.684,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "M65.098 256.179a.807.807 0 0 1 1.363-.584l10.898 10.379c.527.502.172 1.391-.557 1.391H65.904a.807.807 0 0 1-.806-.807v-10.379ZM111.945 287.748a.806.806 0 0 0-1.363-.584l-10.898 10.378c-.527.503-.172 1.391.557 1.391h10.897a.806.806 0 0 0 .807-.806v-10.379Z",
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
  cx: 104.695,
  cy: 259.547,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
  cx: 72.348,
  cy: 292.684,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  d: "M129.445 256.179a.807.807 0 0 1 1.364-.584l10.897 10.379c.528.502.172 1.391-.556 1.391h-10.898a.807.807 0 0 1-.807-.807v-10.379ZM176.293 287.748a.806.806 0 0 0-1.363-.584l-10.898 10.378c-.527.503-.172 1.391.556 1.391h10.898a.806.806 0 0 0 .807-.806v-10.379Z",
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
  cx: 169.043,
  cy: 259.547,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
  cx: 136.695,
  cy: 292.684,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "M193.793 256.179a.807.807 0 0 1 1.363-.584l10.898 10.379c.527.502.172 1.391-.556 1.391H194.6a.807.807 0 0 1-.807-.807v-10.379ZM240.641 287.748a.807.807 0 0 0-1.364-.584l-10.897 10.378c-.528.503-.172 1.391.556 1.391h10.898a.807.807 0 0 0 .807-.806v-10.379Z",
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
  cx: 233.391,
  cy: 259.547,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
  cx: 201.043,
  cy: 292.684,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  d: "M258.141 256.179a.807.807 0 0 1 1.363-.584l10.898 10.379c.527.502.172 1.391-.557 1.391h-10.898a.806.806 0 0 1-.806-.807v-10.379ZM304.988 287.748a.806.806 0 0 0-1.363-.584l-10.898 10.378c-.527.503-.172 1.391.557 1.391h10.897a.806.806 0 0 0 .807-.806v-10.379Z",
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
  cx: 297.738,
  cy: 259.547,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
  cx: 265.391,
  cy: 292.684,
  r: 6.25,
  stroke: "#607189",
  strokeWidth: 1.5
})));
export default SvgTutoringPattern;